import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import Products from './Products';

export const ProductsRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Products />
      </Route>
    </Switch>
  );
};

export default ProductsRoutes;
